import type { UserManager } from 'oidc-client-ts';
import { config } from '../config';
import * as storage from './storage';
import { trace } from './trace';

const saveCurrentRoute = () => {
    const initialRoute = [window.location.hash, window.location.search].join('').replace(/^#\/?/u, '');
    storage.routeStorage.saveRoute(initialRoute);
};

export const attemptInitialSignIn = async (userManager: UserManager) => {
    const isFreshRedirect = window.location.href.includes('redirected');

    try {
        const user = await userManager.signinSilent();
        const initialRoute = storage.routeStorage.getRoute();

        if (initialRoute && isFreshRedirect) {
            window.location.replace(`#/${initialRoute}`);
        }

        storage.routeStorage.discardRoute();
        return await Promise.resolve(user);
    } catch (error) {
        if (config.login.preventRedirect) {
            trace.warn('Auth redirect prevented by config', error);
        } else if (isFreshRedirect) {
            trace.error('Suspicious signin error after redirect', error);
            storage.routeStorage.discardRoute();
        } else {
            saveCurrentRoute();
            userManager.signinRedirect();
        }

        throw new Error('Need to sign in');
    }
};
